<template>
  <div class="main">
    <AvailableProjects
      v-if="!projectId"
      @clickItem="clickItem"
      @pannelEvent="pannelEvent"
      :projectsData="projectsData"
      :editOpenTitle="editOpenTitle"
      :companyId="companyId"
      :company="company"
      :software="software"
    />
    <ProjectDetail
      v-if="projectId"
      :project="projectsData.find((item) => item.id === projectId)"
      :editOpenTitle="editOpenTitle"
      :projectPhaseOptions="projectPhaseOptions"
      :consultants="consultants"
      @clickItem="clickItem"
      @pannelEvent="pannelEvent"
    />
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import AvailableProjects from "./AvailableProjects";
import ProjectDetail from "./ProjectDetail";
import AddProject from "@/components/AddProject";

export default {
  props: ["editOpenTitle"],
  components: {
    AvailableProjects,
    ProjectDetail,
    AddProject,
  },
  data() {
    return {
      companyId: null,
      projectId: null,
      showPanel: false,
      company: null,
      projects: null,
      projectsData: [],
      projectPhases: null,
      projectPhaseOptions: [],
      consultants: null,
      software: null,
    };
  },
  watch: {
    projects() {
      this.projectsData = (this.projects || []).filter(
        (item) => item.public === "true"
      );
    },
    projectPhases() {
      this.projectPhaseOptions = (this.projectPhases || []).map((item) => ({
        text: item.name,
        value: item.name,
      }));
    },
  },
  beforeMount() {
    this.companyId = this.$route.query.id;
    this.bindData();
  },
  methods: {
    bindData: function () {
      this.$bind("company", db.collection("companies").doc(this.companyId));
      this.$bind(
        "projects",
        db.collection("gigs").where("company", "==", this.companyId)
      );
      this.$bind("projectPhases", db.collection("project_phases"));
      this.$bind("consultants", db.collection("consultants"));
      this.$bind("software", db.collection("software"));
    },
    clickItem: function (id) {
      this.projectId = id;
    },
    togglePanel: function () {
      if (this.showPanel) {
        this.onClosePanel();
      } else {
        this.showPanel = !this.showPanel;
      }
    },
    onClosePanel: function () {
      if (
        confirm(
          "Do you want to close the add project window? You will lose all your progress."
        )
      ) {
        this.closePanel();
      }
    },
    closePanel: function () {
      this.showPanel = false;
    },
    pannelEvent: function (param) {
      this.$emit("openEditPannelTitle", param);
    },
  },
};
</script>

<style scoped>
.main {
  flex-grow: 1;
}
.wrapper {
  position: relative;
  height: calc(100vh - 65px);
}
.wrapper > .bg {
  padding-top: 32px;
  background: transparent !important;
  overflow: scroll;
  height: calc(100vh - 65px) !important;
  min-height: calc(100vh - 65px);
  box-sizing: border-box;
}
.detail-wrapper {
  overflow: scroll;
  height: calc(100% - 24px);
  padding-top: 24px;
}
.back {
  margin-left: 24px;
  margin-top: 24px;
}
a {
  font-family: "avenir-next-block";
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
}
a.tab {
  font-family: "avenir-next";
  font-weight: normal !important;
}
.mask {
  position: absolute !important;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  top: 0;
  left: 0;
}
</style>
